// API Configuration for switching between OpenAI and Gemini
export const API_PROVIDERS = {
  OPENAI: 'openai',
  GEMINI: 'gemini',
  DEMO: 'demo'
};

// Current API provider - change this to switch APIs
// Check if API key exists and is not empty/undefined
const hasOpenAIKey = process.env.REACT_APP_OPENAI_API_KEY && process.env.REACT_APP_OPENAI_API_KEY.trim() !== '';
export const CURRENT_API_PROVIDER = hasOpenAIKey ? API_PROVIDERS.OPENAI : API_PROVIDERS.DEMO;

// API Configuration
export const API_CONFIG = {
  [API_PROVIDERS.OPENAI]: {
    name: 'OpenAI',
    models: {
      primary: 'gpt-4o-mini',
      reasoning: 'gpt-4o',
      fast: 'gpt-3.5-turbo'
    },
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
    baseURL: 'https://api.openai.com/v1',
    maxTokens: {
      step1: 1000,
      step2: 1500,
      step3: 2000
    },
    temperature: 0.3
  },
  
  [API_PROVIDERS.GEMINI]: {
    name: 'Google Gemini',
    models: {
      primary: 'gemini-1.5-flash',
      reasoning: 'gemini-1.5-pro',
      fast: 'gemini-1.5-flash'
    },
    apiKey: process.env.REACT_APP_GEMINI_API_KEY,
    baseURL: 'https://generativelanguage.googleapis.com/v1beta',
    maxTokens: {
      step1: 1000,
      step2: 1500,
      step3: 2000
    },
    temperature: 0.3
  },
  
  [API_PROVIDERS.DEMO]: {
    name: 'Demo Mode',
    models: {
      primary: 'demo-model',
      reasoning: 'demo-model',
      fast: 'demo-model'
    },
    apiKey: null,
    baseURL: null,
    maxTokens: {
      step1: 1000,
      step2: 1500,
      step3: 2000
    },
    temperature: 0.3
  }
};

// Get current API configuration
export const getCurrentAPIConfig = () => {
  return API_CONFIG[CURRENT_API_PROVIDER];
};

// Check if current API is configured
export const isAPIConfigured = () => {
  const config = getCurrentAPIConfig();
  return !!config.apiKey;
};

// Get model for complexity level
export const getModelForComplexity = (complexity = 'medium') => {
  const config = getCurrentAPIConfig();
  switch (complexity) {
    case 'high':
      return config.models.reasoning;
    case 'medium':
      return config.models.primary;
    case 'low':
      return config.models.fast;
    default:
      return config.models.primary;
  }
};

// Format API key environment variable name
export const getAPIKeyEnvVar = () => {
  switch (CURRENT_API_PROVIDER) {
    case API_PROVIDERS.OPENAI:
      return 'REACT_APP_OPENAI_API_KEY';
    case API_PROVIDERS.GEMINI:
      return 'REACT_APP_GEMINI_API_KEY';
    default:
      return 'REACT_APP_OPENAI_API_KEY';
  }
};

// Instructions for setting up API keys
export const getSetupInstructions = () => {
  const envVar = getAPIKeyEnvVar();
  const providerName = getCurrentAPIConfig().name;
  
  return {
    provider: providerName,
    envVar: envVar,
    instructions: [
      `Get your ${providerName} API key from the official provider`,
      `Create/update your .env file in the project root`,
      `Add: ${envVar}=your_api_key_here`,
      'Restart your development server',
      'Test the connection using the admin panel'
    ]
  };
}; 